import { Breadcrumb } from '../../types';

export const paymentBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'allPayments',
		{
			name: 'allPayments',
			to: '/payment/all',
			i18nKey: 'breadcrumb.paymentAll',
		},
	],
	[
		'allTransactions',
		{
			name: 'allTransactions',
			to: '/payment/transactions',
			i18nKey: 'breadcrumb.transactionAll',
		},
	],
	[
		'paymentDetails',
		{
			name: 'paymentDetails',
			i18nKey: 'breadcrumb.paymentDetails',
		},
	],
	[
		'cashBalance',
		{
			name: 'cashBalance',
			to: '/payment/cash-balance',
			i18nKey: 'breadcrumb.paymentCashBalance',
		},
	],
	[
		'newManualPayment',
		{
			name: 'newManualPayment',
			to: '/payment/new',
			i18nKey: 'breadcrumb.paymentNewManualPayment',
		},
	],
]);
